import FeatureEntity from './Feature';
import Feature from './FeatureComponent';
import featureInitializer from './featureInitializer';

featureInitializer();

export default Feature;
export { FeatureEntity };



// WEBPACK FOOTER //
// ./src/components/atoms/Feature/index.js